export default "https://cdn-static.gokick.com/assets/f142aa9afb455fb94cf2718539e479c66bf8a410/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";